// extracted by mini-css-extract-plugin
module.exports = {"HourlyForecast":"styles_HourlyForecast__3gRES","heading":"styles_heading__12gvB","itemsWrapper":"styles_itemsWrapper__7Dixp"};